import styled from "styled-components";

export const TemplateWrapper = styled.div`
  width: fit-content;
  height: fit-content;
  border-radius: 10px;
`;
export const Box = styled.div`
  position: relative;
  display: inline-block;
`;
export const Image = styled.div`
  width: fit-content; /* Adjust width as needed */
  height: fit-content;
`;
export const ButtonsContainer = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  opacity: ${({ show }) => (show ? 0.5 : 0)};
  transition: opacity 0.3s ease;
  z-index: 1000;
  background-color: red;
  width: 100%;
  height: 100%;
  border-radius: 10px;
  display: flex;
  justify-content: center;
  align-items: end;
  background-color: #fff;
`;

export const Button = styled.button`
  margin: 5px;
  padding: 8px 16px;
  background-color: #007bff; /* Example background color */
  color: #ffffff; /* Example text color */
  border: none;
  cursor: pointer;
`;
export const TemplateName = styled.div`
  position: absolute;
  bottom: 0;
  width: 90%;
  height: 40px;
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;
